import { yup } from '@guiker/shared-framework'

export const approveInvestorProfileSchema = yup.object({
  investmentRules: yup
    .object({
      twelveMonthsAllowanceLimit: yup.number().required(),
    })
    .required(),
})
